// angular
import {Component, inject} from "@angular/core";
// material angular
import {MatIconModule} from "@angular/material/icon";
import {MatMenuModule} from "@angular/material/menu";
import {MatButtonToggleModule} from "@angular/material/button-toggle";
// services
import {LayoutService} from "../shared/services/layout.service";
// types
import {Theme} from "@app/shared/types/theme.type";

@Component({
  selector: "app-setting-menu",
  templateUrl: "./setting-menu.component.html",
  styleUrls: ["./setting-menu.component.scss"],
  standalone: true,
  imports: [MatIconModule, MatMenuModule, MatButtonToggleModule],
})
export class SettingMenuComponent {
  public theme: Theme;

  // dependencies
  private _layoutService = inject(LayoutService);

  constructor() {
    this._layoutService.theme$.subscribe((theme) => (this.theme = theme));
  }

  public toggleTheme(event: {value: Theme}) {
    this._layoutService.updateTheme(event.value);
  }
}
